import type {SlamPointCloudCreate} from '@/domain/entities/SlamPointCloud';
import type {SlamPointCloudRepository} from '@/domain/interfaces/SlamPointCloudRepository';

export class CreateSlamPointCloudsUseCase {
  constructor(private readonly repository: SlamPointCloudRepository) {}
  async execute(entity: SlamPointCloudCreate, file: File) {
    const pointCloud = await this.repository.create(entity);
    if (pointCloud) {
      const urls = await this.repository.getUrls(pointCloud.uuid);
      return this.repository.upload(urls.uploadUrl, file);
    }
  }
}
